export default "__VITE_ASSET__XzjFIEq$__"